import React from "react";
import { Box, Chip, ChipProps, Typography } from "@mui/material";

interface ListCardHeaderProps {
  icon: React.ReactNode;
  title: React.ReactNode;
  status?: {
    label: string;
    color?: ChipProps["color"];
    icon?: React.ReactElement<any>;
  };
    rightElement?: React.ReactNode;
    hasEdit?: boolean | null;
}

const ListCardHeader: React.FC<ListCardHeaderProps> = ({ icon, title, status, rightElement, hasEdit }) => {
  const rightContent = rightElement ?? (status ? (
    <Chip label={status.label} color={status.color ?? "default"} size="small" icon={status.icon} />
  ) : null);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        mb: 1,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        {icon}
        <Typography variant="h6" fontWeight="bold">
          {title}
              </Typography>
              {hasEdit && rightContent }
      </Box>
          {!hasEdit && rightContent}
    </Box>
  );
};

export default ListCardHeader;
